import React from "react";
import { useNavigate } from "react-router-dom";
import { prefetchRoute } from "../routePrefetch";

const navigationItems = [
  {
    name: "upload",
    path: "/upload",
    icon: (
      <svg viewBox="0 0 24 24" style={{ width: 22, height: 22, stroke: "#6a3fa0", strokeWidth: 5, fill: "none" }}>
        <rect x="3" y="3" width="18" height="14" rx="2" strokeWidth="3" stroke="#6a3fa0" fill="none" />
        <path d="M8 20h8M12 17v3" strokeWidth="3" />
        <path d="M10 10l2-2 2 2M12 8v5" strokeWidth="3" />
      </svg>
    )
  },
  {
    name: "inbox",
    path: "/inbox",
    icon: (
      <svg viewBox="0 0 24 24" style={{ width: 24, height: 24, stroke: "#ffffff", strokeWidth: 4.5, fill: "none" }}>
        <path d="M3 6h18v12H3z" />
        <path d="M3 7l9 7 9-7" />
      </svg>
    )
  },
  {
    name: "discover",
    path: "/discover",
    icon: (
      <svg viewBox="0 0 24 24" style={{ width: 24, height: 24, stroke: "#ffffff", strokeWidth: 4.5, fill: "none" }}>
        <circle cx="11" cy="11" r="6" />
        <path d="M20 20l-4-4" />
      </svg>
    )
  },
  {
    name: "profile",
    path: "/profile",
    icon: (
      <svg viewBox="0 0 24 24" style={{ width: 24, height: 24, stroke: "#ffffff", strokeWidth: 4.5, fill: "none" }}>
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c2-4 14-4 16 0" />
      </svg>
    )
  },
  {
    name: "home",
    path: "/",
    icon: (
      <svg viewBox="0 0 24 24" style={{ width: 24, height: 24, stroke: "#ffffff", strokeWidth: 4.5, fill: "none" }}>
        <path d="M4 10l8-6 8 6v10H4z" />
      </svg>
    )
  }
];

function VideoNavigation({ inboxBadge = 0 }) {
  const navigate = useNavigate();

  const goTo = (path) => {
    navigate(path);
  };

  const rightPos = window.innerWidth > 480
    ? `calc(50% - 240px)`
    : 0;

  return (
    <div
      style={{
        position: "fixed",
        right: rightPos,
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 100,
        maxWidth: 56
      }}
    >
      <div
        style={{
          padding: "14px 10px",
          background: "transparent",
          backdropFilter: "blur(3px)",
          display: "flex",
          flexDirection: "column",
          gap: 18,
          alignItems: "center",
          opacity: 1
        }}
      >
        {navigationItems.map((item) => (
          <button
            key={item.name}
            onPointerEnter={() => prefetchRoute(item.path)}
            onTouchStart={() => prefetchRoute(item.path)}
            onClick={(event) => {
              event.stopPropagation();
              goTo(item.path);
            }}
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              border: "2px solid #000",
              outline: "1px solid rgba(255,255,255,0.75)",
              background: "rgba(180,180,180,0.32)",
              color: "#fff",
              fontSize: 16,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(2px)",
              WebkitBackdropFilter: "blur(2px)",
              boxShadow: "0 0 0 1.5px #000",
              cursor: "pointer",
              touchAction: "manipulation"
            }}
          >
            <span
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              {item.icon}

              {item.name === "inbox" && inboxBadge > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: -6,
                    right: -8,
                    background: "linear-gradient(135deg,#8B5FBF,#6a3fa0)",
                    border: "2px solid #000",
                    borderRadius: 10,
                    minWidth: 16,
                    height: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 9,
                    fontWeight: 900,
                    color: "#fff",
                    lineHeight: 1,
                    padding: "0 3px",
                    boxSizing: "border-box",
                    boxShadow: "0 1px 6px rgba(106,63,160,0.8)"
                  }}
                >
                  {inboxBadge > 99 ? "99+" : inboxBadge}
                </span>
              )}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default React.memo(VideoNavigation);
